import easydropdown from "easydropdown-a11y";
import "@styles/components/dropdown.css";

const init = () => {
  const product = document.querySelector(".product-details");
  const sizesJson = document.getElementById("product-sizes-data");
  const sizeSelect = product.querySelector(".product-sizes");
  const purchasePrice = product.querySelector(".product-purchase-price");
  const purchaseLink = product.querySelector(".product-purchase-link");

  if (sizeSelect) {
    const sizes = JSON.parse(sizesJson.textContent);

    const opts = {
      behavior: {
        openOnFocus: true,
        maxVisibleItems: 10,
        liveUpdates: true,
        useNativeUiOnMobile: false,
      },
      callbacks: {
        onSelect: (value) => {
          const selectedSize = sizes[value];

          purchaseLink.classList.remove("invisible");
          purchaseLink.href = selectedSize.link;

          purchasePrice.classList.remove("hidden");
          purchasePrice.textContent = selectedSize.price;
        },
      },
    };

    easydropdown(sizeSelect, opts);
  }
};

init();
